<template>
    <div style="padding: 2%; max-width: 1200px; margin: 0 auto">
        <div v-if="isPhone" style="padding:0 2px;text-align: right">
            <HomeIcon/>
        </div>
        <a-tabs>
            <a-tab-pane key="0" tab="个人信息">
                <div class="blue-bg bottom">
                    <p style="font-size: 24px;">
                        <b><UserOutlined/> {{aliasInput}}</b>
                    </p>
                </div>
                <div style="background: #F5F5F5; border-radius: 6px; padding: 20px">
                    <div style="margin-bottom: 15px">
                        <div>
                            <b>用户名：</b><span>
                        <a-space v-if="isEditAlias">
                            <a-input v-if="isEditAlias" v-model:value="aliasInput"/>
                            <a @click="cancelEditAlias">取消</a>|<a @click="saveAlias">保存</a>
                        </a-space>
                    <a-space v-else>
                        {{aliasInput || account}}
                        <a @click="editAlias"><EditOutlined/></a>
                    </a-space>
                    </span>
                        </div>
                        <div style="color: red" v-if="aliasMsg">{{aliasMsg}}</div>
                    </div>
                    <div style="margin-bottom: 15px">
                        <b>手机号：</b>{{userInfo.tel}}
                    </div>
                    <div>
                        <b>密&nbsp;&nbsp;&nbsp;码：</b> {{userInfo?.password_set? '******': '未设置'}} <a @click="editPwd"><EditOutlined/></a>
                    </div>
                </div>
                <div style="height: 20vh"></div>
                <div  v-if="isDEV" style="background: #F5F5F5; border-radius: 6px; padding: 20px;">
                    <p style="margin-top: 15px">
                        <a-button @click="handleGrant">授权</a-button>
                    </p>
                    <a-divider orientation="left">解除绑定</a-divider>
                    <div>
                        <a-space>
                            <UnbindTel/>
                        </a-space>
                    </div>
                </div>
                <a-modal v-model:open="open" @ok="()=>onOk" width="400px" :footer="null">
                    <ResetPassword :tel="userInfo.tel"/>
                </a-modal>
            </a-tab-pane>
            <a-tab-pane key="1" tab="我的积分">
                <div class="blue-bg bottom">
                    <div>
                        <p>
                            我的积分
                            <span style="float: right"><GiftOutlined  class="account-icon"/></span>
                        </p>

                    </div>
                    <span style="font-size: 28px">{{point}}</span>

                </div>

                <a-row :gutter="12" class="bottom">
                    <a-col span="12" :xs="24" :md="12">
                        <a-card title="积分变更" class="card" :loading="loadingRecords">
                            <jy-echarts v-if="option" :option="option"></jy-echarts>
                        </a-card>
                    </a-col>
                    <a-col span="12" :xs="24" :md="12">
                        <a-card title="积分消耗" class="card" :loading="loadingDaily">
                            <jy-echarts v-if="option2" :option="option2"></jy-echarts>
                        </a-card>

                    </a-col>
                </a-row>
                <a-card title="积分历史">
                    <a-tabs v-model:activeKey="activeKey" @change="handleChange">
                        <a-tab-pane key="1" tab="全部"></a-tab-pane>
                        <a-tab-pane key="2" tab="充值"></a-tab-pane>
                        <a-tab-pane key="3" tab="消耗"></a-tab-pane>
                        <template #rightExtra>
                            <RedoOutlined @click="getRecords"/>
                        </template>
                    </a-tabs>
                    <a-table
                            size="small"
                            :data-source="dataSource" :columns="columns"
                            :loading="loadingRecords">
                        <template #point_type="{ record }">
                            <span>
                                <a-tag v-if="record.points < 0" color="orange">
                                    消耗
                                </a-tag>
                                <a-tag v-else color="green">
                                    充值
                                </a-tag>
                            </span>
                        </template>
                        <template #points="{ record }">
                            <span>
                                <a-typography-text :type="record.points < 0? 'danger': 'success'">
                                    {{record.points}}
                                </a-typography-text>
                            </span>
                        </template>
                    </a-table>
                </a-card>
            </a-tab-pane>
            <a-tab-pane key="2" tab="积分管理" force-render v-if="isAdmin">
                <a-card title="积分充值">
                    <points-admin/>
                </a-card>
            </a-tab-pane>
            <a-tab-pane key="3" tab="兑换码管理" force-render v-if="isAdmin">
                <a-card title="兑换码">
                    <CouponCode/>
                </a-card>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script setup>
    import {onMounted, ref} from 'vue';
    import { UserOutlined, GiftOutlined, RedoOutlined, EditOutlined} from '@ant-design/icons-vue';
    import JyEcharts from '../../components/JyEcharts';
    import HomeIcon from '../../components/HomeIcon';
    import PointsAdmin from './AccountAdmin';
    import CouponCode from './CouponCode';
    import ResetPassword from "./ResetPassword";
    import UnbindTel from "../login/UnbindTel";
    import {getAccount, isPhone, jumpToLogin} from "../../utils/llm.tools";
    import {
        get_biogpt_admin_points_daily,
        get_biogpt_admin_points_records,
        get_biogpt_user_info
    } from "../../utils/bioinfo.api";
    import {jy_tip} from "../../utils/vue.tool";
    import {compare, isDEV} from "../../utils/request";
    import {
        post_auth_token_confirm,
        put_user_alias} from "../../utils/paper.account";
    import {get_user, post_grant_genetic} from "../../utils/api";
    const account = getAccount();
    let dataSource = ref([]);
    let initData = ref([]);
    let loadingScore = ref(true);
    let loadingRecords = ref(true);
    let loadingDaily = ref(true);
    let point = ref(0);
    let option = ref(undefined);
    let option2 = ref(undefined);
    let isEditAlias = ref(false);
    let aliasInput = ref(account);
    let aliasMsg = ref('');

    let open = ref(false);
    let userInfo = ref({});
    // 【record_no】记录编号【points】变更积分值【balance_after】变更后积分值【add_datetime】记录时间【description】描述

    let columns = [
        {title: '日期', dataIndex: 'add_datetime', defaultSortOrder: 'descend', sorter: compare('add_datetime')},
        {title: '类型', dataIndex: 'point_type', slots: { customRender: 'point_type' },},
        {title: '详情', dataIndex: 'description', slots: { customRender: 'description' },},
        {title: '积分', dataIndex: 'points', slots: { customRender: 'points' },},
        {title: '余额', dataIndex: 'balance_after', slots: { customRender: 'balance_after' },},
    ];
    let isAdmin = ref(false);
    let tel = ref('');
    const editAlias = ()=> isEditAlias.value = true;
    const cancelEditAlias = ()=> {
        isEditAlias.value = false;
        aliasMsg.value = '';
    };
    const saveAlias = ()=> {
        // editAlias
        put_user_alias({alias: aliasInput.value}, (res)=>{
            let {status, message} = res;
            if(status === 1000001) {
                jy_tip('用户名已修改');
                isEditAlias.value = false;
                aliasMsg.value = '';
                let user_info = localStorage.getItem('user_info');
                if(user_info) {
                    user_info = JSON.parse(user_info);
                } else user_info = {};
                user_info.alias = aliasInput.value;
                localStorage.setItem('user_info', JSON.stringify(user_info));
            }
            else aliasMsg.value = ('修改失败: ' + message)
        })
    };
    const editPwd = () => open.value = true;
    onMounted(()=>{
        post_auth_token_confirm(res=>{
            let {status} = res;
            if(status !== 1) {
                if(!isDEV) jumpToLogin();
            }
            else {
                get_user(res=>{
                    let {data} = res;
                    data = data || {};
                    isAdmin.value = data?.level === 'E';
                    // localStorage.getItem('level') === 'E'
                    let user_info = localStorage.getItem('user_info');
                    if(user_info) user_info = JSON.parse(user_info);
                    // else post_auth_token_confirm(res2=>{
                    //
                    // })
                    console.log('user_info', user_info);
                    data = {...data, ...user_info};
                    tel.value = data?.tel;
                    userInfo.value = data;

                });
                get_biogpt_user_info((res)=>{
                    let {data, message} = res;
                    if(data){
                        let {points} = data;
                        point.value = points;
                    }
                    else {
                        jy_tip('获取我的积分失败：' + message);
                    }

                    loadingScore.value = false;
                });
                getRecords();
                get_biogpt_admin_points_daily((res)=>{
                    let {data, message} = res;
                    if(data){
                        let series = [];
                        if(Array.isArray(data)){
                            let x = [];
                            data.sort(compare('date'));
                            data.map((item, index)=>{
                                let { date} = item;
                                if(x.indexOf(date) === -1) {
                                    x.push(date);
                                }

                                Object.keys(item).map(k=>{
                                    if(k !== 'date') {
                                        let sItemIndex = series.findIndex(s=> s.name === k);
                                        if(sItemIndex === -1){
                                            sItemIndex = series.length;
                                        }
                                        console.log(sItemIndex, k, item[k]);
                                        let sItem = series[sItemIndex] || {
                                            name: k ,
                                            type: 'bar',
                                            stack: '消耗',
                                            data: Array.from({length: data.length}).map(()=>{
                                                return {value: 0, name: ''}
                                            })
                                        };
                                        if(sItem){
                                            let values = sItem.data || [];
                                            values[index] = {value: item[k], name: date};
                                            sItem.data = values;
                                            series[sItemIndex] = sItem;
                                        }
                                    }
                                });
                            });
                            series = series.map(s=>{
                                s.data.map(d=> {
                                    if(!d) return '-'
                                });
                                return s;
                            });
                            let s2 = [{
                                name: '对话',
                                type: 'bar',
                                stack: '总量', // 此处的 stack 属性决定了系列是否堆叠，以及堆叠的顺序
                                data: [320, 302, 301, 334, 390, 330, 320]
                            },
                                {
                                    name: '上传',
                                    type: 'bar',
                                    stack: '总量', // 与第一个系列堆叠在一起
                                    data: [120, 132, 101, 134, 90, 230, 210]
                                },];

                            console.log('series', s2);
                            option2.value = {
                                tooltip: {},
                                legend: {},
                                xAxis: {
                                    type: 'category',
                                    data: x
                                },
                                yAxis: {
                                    type: 'value'
                                },
                                series: series
                            };
                        }

                    }
                    else {
                        jy_tip('获取积分变更记录失败：' + message);
                    }
                    loadingDaily.value = false;
                });
            }
        });
    });
    const handleGrant = ()=>{
        post_grant_genetic(account, 'JINGDu', (res)=>{
            console.log('post_grant_genetic', res);
            if(res?.status === 1000002) jy_tip('已授权', 'success');
            else jy_tip('授权失败: ' + (res?.message));
        })
    };
    const getRecords = ()=>{
        loadingRecords.value = true;
        get_biogpt_admin_points_records((res)=>{
            let {data, message} = res;
            loadingRecords.value = false;
            if(data){
                dataSource.value = [...data];
                initData.value = data;
                if(Array.isArray(data)){
                    let x = [];
                    let y = [];
                    data.map(item=>{
                        let {description, balance_after: p, add_datetime, points} = item;
                        if(x.indexOf(add_datetime) === -1) x.push(add_datetime);
                        y.push({
                            value: p,
                            name: description,
                            itemStyle: {
                                color: points < 0? '#d46b08': '#389e0d'
                            }
                        });
                    });
                    option.value = {
                        legend: {},
                        tooltip: {},
                        xAxis: {
                            type: 'category',
                            data: x,
                            nameRotate: 45
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                data: y,
                                type: 'line',
                                smooth: true,
                            }
                        ]
                    };
                }
            }
            else {
                jy_tip('获取积分变更记录失败：' + message);
            }
        });
    };
    const handleChange = (key)=>{
        if(key === '1') dataSource.value = initData.value;
        if(key === '2') dataSource.value = initData.value.filter(d=>d.points >= 0);
        if(key === '3') dataSource.value = initData.value.filter(d=>d.points < 0);
    };
</script>
<style>

    .blue-text{
        color: #335ACB
    }
    .blue-bg{
        background: #335ACB;
        padding: 30px 20px;
        border-radius: 10px;
        color: #fff!important;
    }
    .bottom{
        margin-bottom: 20px;
    }
    .account-icon{
        font-size: 20px;
    }
    .card {
        height: 520px;
        transition: transform 0.3s ease;
    }

    .card:hover {
        transform: translateY(-5px);
    }
    /*@media (max-width: 480px) {*/
    /*    .card{*/
    /*        height: 400px;*/
    /*    }*/
    /*}*/
</style>